module.exports = __webpack_public_path__ + "static/media/icon-godown.d831c944.svg";